import { render, staticRenderFns } from "./orderInfoQry.vue?vue&type=template&id=fd1986fe&scoped=true&"
import script from "./orderInfoQry.vue?vue&type=script&lang=js&"
export * from "./orderInfoQry.vue?vue&type=script&lang=js&"
import style0 from "./orderInfoQry.vue?vue&type=style&index=0&id=fd1986fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1986fe",
  null
  
)

export default component.exports